import LangEnum from '../../../../../../../lang/LangEnum';
import { useCatalogSortClassificationTypeOptions } from '../../../../../hooks/useCatalogSortClassificationTypeOptions';
import CatalogViewSettingsRow from './CatalogViewSettingsRow';
import CatalogViewValueSelect from './CatalogViewValueSelect';

interface CatalogViewClassificationTypeRowProps {
  testId: string;
  value: string | null;
  hasError: boolean;
  onChange: (classificationTypeId: string | null) => void;
}

const CatalogViewClassificationTypeRow = ({
  testId,
  value,
  hasError,
  onChange,
}: CatalogViewClassificationTypeRowProps) => {
  const { options, isLoading, hasNextPage, loadMoreRows } =
    useCatalogSortClassificationTypeOptions(null);

  return (
    <CatalogViewSettingsRow label={LangEnum.CATALOGS_CATALOG_FORM_SORT_TARGET_CLASSIFICATION_TYPE}>
      <CatalogViewValueSelect<string | null>
        label={LangEnum.CATALOGS_CATALOG_FORM_SORT_TARGET_CLASSIFICATION_TYPE}
        value={value}
        testId={testId}
        hasError={hasError}
        infiniteList={{ isLoading, hasNextPage, loadMoreRows }}
        onChange={onChange}
        options={options.map((option) => ({ value: option.id, rawLabel: option.name }))}
      />
    </CatalogViewSettingsRow>
  );
};

export default CatalogViewClassificationTypeRow;
